// #3436 (scribe-quiet-alarms): the device-health object the presence heartbeat
// carries to the Station Monitor. Pure and read-only on purpose: it only
// SHAPES values the app already measures (no new measuring), so the scribe
// screen and the Station Monitor can never disagree about a count.
//
// Sources, all existing:
//   storage*      local/storagePersistence.js's recorded {persisted, supported,
//                 usage, quota} (null before the first check, or unsupported)
//   storageFull   local/storageFailure.js's current failure, kind "quota"
//   authExpired / online / the sync counts / unsyncedRides
//                 ScoreContext (the same values SyncStatus, OfflineIndicator
//                 and UnsyncedRidesIndicator render)
//
// Wire shape is score-api's deviceHealthSchema (handlers/presence.js).
const asCount = (n) => (Number.isInteger(n) && n >= 0 ? n : 0);
const asBytes = (n) => (typeof n === "number" && Number.isFinite(n) && n >= 0 ? n : null);

export function buildDeviceHealth({ persistence, storageFailure, scoreState } = {}) {
  const s = scoreState ?? {};
  // storagePersisted: null when the browser cannot say (unsupported) or no
  // check has completed yet, so the Station Monitor never flags a station for
  // a question that was never answered.
  const storagePersisted =
    persistence && persistence.supported !== false && typeof persistence.persisted === "boolean"
      ? persistence.persisted
      : null;
  return {
    storagePersisted,
    storageUsage: asBytes(persistence?.usage),
    storageQuota: asBytes(persistence?.quota),
    storageFull: storageFailure?.kind === "quota",
    authExpired: Boolean(s.authExpired),
    online: typeof s.online === "boolean" ? s.online : null,
    syncError: asCount(s.errorSync),
    syncStuck: asCount(s.terminalSync),
    syncHeld: asCount(s.heldSync),
    syncBlocked: asCount(s.blockedSync),
    syncPending: asCount(s.pendingSync),
    unsyncedRides: asCount(s.unsyncedRideCount),
  };
}

export default buildDeviceHealth;
